export const normalizeOrgNumberHelper = (orgNumber: string) => {
  const charactersToRemove = /[-]|[ ]|[,]|[.]/g;
  return orgNumber?.replace(charactersToRemove, '');
};
